export const LOCATION_ID_UPDATED = 'LOCATION_ID_UPDATED';
export const PAYMENT_ANSWERS_UPDATED = 'PAYMENT_ANSWERS_UPDATED';
export const FETCH_QUESTIONS_OR_PAYMENT = 'FETCH_QUESTIONS_OR_PAYMENT';
export const PAYMENT_SKIP = 'PAYMENT_SKIP';
export const PAYMENT_FAILURE = 'PAYMENT_FAILURE';
export const PAYMENT_RECEIVED = 'PAYMENT_RECEIVED';
export const PAYMENT_REQUESTED = 'PAYMENT_REQUESTED';
export const PAYMENT_ABORTED = 'PAYMENT_ABORTED';
export const PAYMENT_GRID_ROW_SUPERSEDED = 'PAYMENT_GRID_ROW_SUPERSEDED';

/**
 * Internal actions used exclusively to track the fetchPayments() HTTP call window.
 * These drive the `isFetching` spinner flag and should NOT be used for general
 * payment lifecycle logic. Use PAYMENT_REQUESTED / PAYMENT_RECEIVED instead.
 */
export const PAYMENT_FETCH_STARTED = 'PAYMENT_FETCH_STARTED';
export const PAYMENT_FETCH_COMPLETED = 'PAYMENT_FETCH_COMPLETED';
export const PROGRAMS_END_DAYS = 'PROGRAMS_END_DAYS';
export const SKIPPED_PAYMENT_FAILURE = 'SKIPPED_PAYMENT_FAILURE';
export const SKIPPED_PAYMENT_RECEIVED = 'SKIPPED_PAYMENT_RECEIVED';

export const QUESTIONS_CLEAR = 'QUESTIONS_CLEAR';

export const UPDATED_OFFER_MENU_PRODUCTS = 'UPDATED_OFFER_MENU_PRODUCTS';

export const CLEAR_TAX_AMOUNTS = 'CLEAR_TAX_AMOUNTS';

export const SYNC_MESSAGE = 'SYNC_MESSAGE';

export const INIT_PENCIL_SUCCESS = 'INIT_PENCIL_SUCCESS';

export const ZIP_CODE_PAYMENT_FAILED = 'ZIP_CODE_PAYMENT_FAILED';
export const UPDATED_SHOPPER_CONTACT_PAYMENT_FAILED = 'UPDATED_SHOPPER_CONTACT_PAYMENT_FAILED';
export const TRADE_IN_PAYMENT_FAILED = 'TRADE_IN_PAYMENT_FAILED';
export const INCENTIVES_PAYMENT_FAILED = 'INCENTIVES_PAYMENT_FAILED';
export const CREDIT_TIER_PAYMENT_FAILED = 'CREDIT_TIER_PAYMENT_FAILED';
export const OFFER_PRICE_PAYMENT_FAILED = 'OFFER_PRICE_PAYMENT_FAILED';
export const DOWN_PAYMENT_PAYMENT_FAILED = 'DOWN_PAYMENT_PAYMENT_FAILED';
export const ANNUAL_MILES_PAYMENT_FAILED = 'ANNUAL_MILES_PAYMENT_FAILED';
export const UPDATED_SHOPPER_ZIP = 'UPDATED_SHOPPER_ZIP';
export const UPDATED_OFFER_TYPE = 'UPDATED_OFFER_TYPE';
export const UPDATED_DAYS_TO_FIRST_PAYMENT = 'UPDATED_DAYS_TO_FIRST_PAYMENT';
export const UPDATED_SPECIAL_PAYMENT_FORMULA = 'UPDATED_SPECIAL_PAYMENT_FORMULA';
export const RESET_SPECIAL_PAYMENT_FORMULA = 'RESET_SPECIAL_PAYMENT_FORMULA';
export const UPDATE_CONTRACT_DATE = 'UPDATE_CONTRACT_DATE';
export const UPDATED_USE_CALCULATED_GOV_FEES = 'UPDATED_USE_CALCULATED_GOV_FEES';
export const UPDATED_PAYMENT_FREQUENCY = 'UPDATED_PAYMENT_FREQUENCY';
